import styled from "styled-components";

const Label = styled.div`
  background: rgba(133, 113, 77, 0.1);
  border-radius: 0px 4px;
  padding: 4px 8px;
  color: #85714d;
  align-self: center;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  color: #85714d;
`;

export default Label;
